// src/client/task-types/index.js

const {htmlCssModules} = require('./html-css');
const {htmlCssChallengeModules} = require('./html-css-challenge');
const {htmlCssJsIframeChallengeModules} = require('./html-css-js-iframe-challenge');
const {htmlCssJsModules} = require('./html-css-js');
const {htmlCssJsChallengeModules} = require('./html-css-js-challenge');
const {htmlLessModules} = require('./html-less');
const {htmlLessChallengeModules} = require('./html-less-challenge');
const {jsModules} = require('./js');
const {jsChallengeModules} = require('./js-challenge');
const {svgCssModules} = require('./svg-css');
const {svgCssChallengeModules} = require('./svg-css-challenge');
const {theoryModules} = require('./theory');

const {phpModules} = require('./php');

const {mfHtmlCssModules} = require('./mf/html-css');
const {mfHtmlCssChallengeModules} = require('./mf/html-css-challenge');
const {mfHtmlLessModules} = require('./mf/html-less');
const {mfHtmlLessChallengeModules} = require('./mf/html-less-challenge');
const {mfHtmlCssJsModules} = require('./mf/html-css-js');
const {mfHtmlCssJsIframeChallengeModules} = require('./mf/html-css-js-iframe-challenge');
const {mfSvgCssModules} = require('./mf/svg-css');
const {mfSvgCssChallengeModules} = require('./mf/svg-css-challenge');

const typeToModules = {
  'html': htmlCssModules,
  'html-css': htmlCssModules,
  'html-css-challenge': htmlCssChallengeModules,
  'html-css-js-iframe-challenge': htmlCssJsIframeChallengeModules,
  'html-css-js': htmlCssJsModules,
  'html-css-js-challenge': htmlCssJsChallengeModules,
  'html-less': htmlLessModules,
  'html-less-challenge': htmlLessChallengeModules,
  'js': jsModules,
  'js-challenge': jsChallengeModules,
  'svg-css': svgCssModules,
  'svg-css-challenge': svgCssChallengeModules,
  'theory': theoryModules,

  'php': phpModules,

  'mf/html-css': mfHtmlCssModules,
  'mf/html-css-challenge': mfHtmlCssChallengeModules,
  'mf/html-less': mfHtmlLessModules,
  'mf/html-less-challenge': mfHtmlLessChallengeModules,
  'mf/html-css-js': mfHtmlCssJsModules,
  'mf/html-css-js-iframe-challenge': mfHtmlCssJsIframeChallengeModules,
  'mf/svg-css': mfSvgCssModules,
  'mf/svg-css-challenge': mfSvgCssChallengeModules,
};

const getModules = (taskType) => {
  return typeToModules[taskType];
};

module.exports = {
  getModules,
};
